import cls from "classnames"

import Icon from "../../../../Icon"

const OnboardingStep = ({ label, done, active, process, sub, onClick }) => {
  return (
    <button
      className={cls("ob-step", {
        "is-active": active,
        "is-done": done,
        "is-process": process
      })}
      onClick={onClick}
      type="button"
    >
      <span
        className={cls("ob-step__marker", {
          "is-done": done,
          "is-sub": sub
        })}
      >
        <span className="ob-step__circle" />
        {done && <Icon className="ob-step__icon" type="check_full" />}
      </span>

      <span className={cls("ob-step__label", { "is-done": done })}>{label}</span>
    </button>
  )
}

export default OnboardingStep
